/**
 * Added to Cart Message on click
 */

(function() {
  'use strict';

  const CONFIG = {
    messageText: 'Added to cart',
    displayDuration: 2000,
    fadeDuration: 300
  };

  function injectStyles() {
    var styleId = 'add-to-cart-msg-styles';
    if (document.getElementById(styleId)) {
      return; 
    }

    var style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      [data-add-to-cart-text].fade-transition,
      button[data-add-to-cart].fade-transition,
      input.product-grid-section__addtocart.fade-transition,
      input.quick-shop-section__addtocart.fade-transition {
        transition: opacity ${CONFIG.fadeDuration}ms ease-in-out;
      }
      [data-add-to-cart-text].fade-out,
      button[data-add-to-cart].fade-out,
      input.product-grid-section__addtocart.fade-out,
      input.quick-shop-section__addtocart.fade-out {
        opacity: 0;
      }
      [data-add-to-cart-text].fade-in,
      button[data-add-to-cart].fade-in,
      input.product-grid-section__addtocart.fade-in,
      input.quick-shop-section__addtocart.fade-in {
        opacity: 1;
      }
    `;
    document.head.appendChild(style);
  }

  var messageShown = false;
  
  function showAddedToCartMessage(addToCartBtn) {
    if (!addToCartBtn) {
      return;
    }

    if (messageShown) {
      return;
    }
    
    messageShown = true;
    setTimeout(function() {
      messageShown = false;
    }, 3000);

    var addToCartText = addToCartBtn.querySelector('[data-add-to-cart-text]');
    var originalText = null;
    var textElement = null;
    var isInput = addToCartBtn.tagName === 'INPUT' && addToCartBtn.type === 'submit';

    if (addToCartText) {
      textElement = addToCartText;
      originalText = addToCartText.dataset.defaultText || addToCartText.textContent;
    } else if (isInput) {
      textElement = addToCartBtn;
      originalText = addToCartBtn.value || addToCartBtn.getAttribute('value') || '';
    } else {
      textElement = addToCartBtn;
      originalText = addToCartBtn.textContent.trim();
    }

    if (!textElement.dataset.originalText) {
      textElement.dataset.originalText = originalText;
    }

    textElement.classList.add('fade-transition');
    textElement.classList.add('fade-out');
    
    setTimeout(function() {
      if (isInput) {
        textElement.value = CONFIG.messageText;
      } else {
        textElement.textContent = CONFIG.messageText;
      }
      
      textElement.classList.remove('fade-out');
      textElement.classList.add('fade-in');
      
      setTimeout(function() {
        textElement.classList.remove('fade-in');
        textElement.classList.add('fade-out');
        
        setTimeout(function() {
          var textToRestore = textElement.dataset.originalText || originalText;
          if (isInput) {
            textElement.value = textToRestore;
          } else {
            textElement.textContent = textToRestore;
          }
          
          textElement.classList.remove('fade-out');
          textElement.classList.add('fade-in');
          
          setTimeout(function() {
            textElement.classList.remove('fade-in', 'fade-transition');
          }, CONFIG.fadeDuration);
        }, CONFIG.fadeDuration);
      }, CONFIG.displayDuration);
    }, CONFIG.fadeDuration);
  }

  function isFormSubmissionSuccessful(button) {
    var form = button.closest('form');
    if (!form) {
      return true;
    }

    var errorElements = form.querySelectorAll('.errors');
    return errorElements.length === 0;
  }

  function monitorButtonState(button) {
    if (!button) return;

    var clickTimeout = null;
    var hasShownMessage = false;
    
    button.addEventListener('click', function(evt) {
      hasShownMessage = false;
    
      if (clickTimeout) {
        clearTimeout(clickTimeout);
      }
      
      clickTimeout = setTimeout(function() {
        if (!hasShownMessage) {
          var form = button.closest('form');
          var hasErrors = form && form.querySelectorAll('.errors').length > 0;
          
          if (!hasErrors) {
            showAddedToCartMessage(button);
            hasShownMessage = true;
          }
        }
      }, 1000);
    }, true);

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          var hasLoading = button.classList.contains('btn--loading');
          var hadLoading = mutation.oldValue && mutation.oldValue.includes('btn--loading');
          
          if (hadLoading && !hasLoading) {
            setTimeout(function() {
              if (isFormSubmissionSuccessful(button)) {
                showAddedToCartMessage(button);
                hasShownMessage = true;
              }
            }, 200);
          }
        }
      });
    });

    observer.observe(button, {
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ['class']
    });
  }

  function init() {
    document.addEventListener('ajaxProduct:added', function(evt) {
      if (evt.detail && evt.detail.addToCartBtn) {
        showAddedToCartMessage(evt.detail.addToCartBtn);
      }
    }, true);

    function setupButtonMonitoring() {
      var addToCartButtons = document.querySelectorAll('[data-add-to-cart]');
      var productGridInputs = document.querySelectorAll('input.product-grid-section__addtocart, input.quick-shop-section__addtocart');
      
      addToCartButtons.forEach(function(button) {
        monitorButtonState(button);
      });
      
      productGridInputs.forEach(function(input) {
        monitorButtonState(input);
      });
    }

    setupButtonMonitoring();

    var formObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            var newButtons = node.querySelectorAll ? node.querySelectorAll('[data-add-to-cart]') : [];
            var newInputs = node.querySelectorAll ? node.querySelectorAll('input.product-grid-section__addtocart, input.quick-shop-section__addtocart') : [];
            
            if (node.hasAttribute && node.hasAttribute('data-add-to-cart')) {
              newButtons = [node].concat(Array.from(newButtons));
            }
            
            if (node.tagName === 'INPUT' && (node.classList.contains('product-grid-section__addtocart') || node.classList.contains('quick-shop-section__addtocart'))) {
              newInputs = [node].concat(Array.from(newInputs));
            }
            
            newButtons.forEach(function(button) {
              if (!button.dataset.monitored) {
                button.dataset.monitored = 'true';
                monitorButtonState(button);
              }
            });
            
            newInputs.forEach(function(input) {
              if (!input.dataset.monitored) {
                input.dataset.monitored = 'true';
                monitorButtonState(input);
              }
            });
          }
        });
      });
    });

    formObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  injectStyles();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();